import { environment } from "../config/environment";
import { customFetch } from "./Auth";

export async function fetchPatientConversationIds(patientId) {
  if (!patientId) {
    return { success: false, error: "No patient ID" };
  }

  try {
    const response = await customFetch(
      `${environment.apiUrl}/patients/realtime-audio-chunks/conversations/by-patient/${encodeURIComponent(patientId)}`,
      { method: "GET" }
    );
    const result = await response.json();

    if (!response.ok || !result.success) {
      return {
        success: false,
        error: result.error || "Failed to load conversation IDs",
      };
    }

    return {
      success: true,
      conversations: Array.isArray(result.conversations)
        ? result.conversations
        : [],
    };
  } catch {
    return { success: false, error: "Failed to load conversation IDs." };
  }
}

export function buildMergeAudioChunksEvent(conversationId) {
  return {
    Records: [
      {
        body: JSON.stringify({
          Message: conversationId,
        }),
      },
    ],
  };
}

export function buildMergeAudioChunksEventJson(conversationId, indent = 2) {
  return JSON.stringify(buildMergeAudioChunksEvent(conversationId), null, indent);
}
